<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">ACM MM 2024｜腾讯优图实验室10篇论文入选，含跨模态融合、多模态大语言模型、扩散变换器、域泛化语义分割等研究方向</div>
      <div class="news-date">2024年9月20日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          近期，第32届ACM国际多媒体大会（Proceedings of the 32nd ACM International Conference on Multimedia，ACM MM 2024）公布了论文录用结果，会议共收到4385篇投稿，共录用1149篇论文，录用率约为26.2%。ACM MM自 1993 年首次召开以来，每年召开一次，已经成为多媒体领域以及多模态领域中的顶级国际会议，也是中国计算机学会（CCF）收录的计算机图形学与多媒体领域A类会议。ACM MM 2024将于10月28日至11月1日在澳大利亚墨尔本举行。
        </p>
        <p>
          今年，腾讯优图实验室共有10篇论文被录用，内容涵盖含跨模态融合、多模态大语言模型、扩散变换器、域泛化语义分割等研究方向，展示了腾讯优图实验室在人工智能领域的技术能力和研究成果。
        </p>
        <p>
          以下为入选论文概览：
        </p>
        <div class="news-content-mark">
          <div>01</div>
          <div>面向CLIP的双向自适应跨模态融合提示学习</div>
          <div>Bilateral Adaptive Cross-Modal Fusion Prompt Learning for CLIP</div>
        </div>
        <p class="short-center">
          Qiang Wang, Ke Yan, Shouhong Ding
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news61.png"/>
          </div>
        </div>
        <p>
          利用提示学习将CLIP模型适配到下游任务时，保持视觉和文本表征之间的正确对齐是十分关键的。本文认为，视觉和文本表征在下游任务适配过程中的正确对齐取决于跨模态信息之间交互的灵活性，因为跨模态信息的充分交互可以有效弥补对比损失在适配过程中的缺失。然而，目前的提示学习方法，例如对CLIP的视觉或语言分支进行单独调整，或是采用单向的跨模态融合，都不足以充分挖掘视觉和文本模态之间交互的全部潜力。为了克服这一局限性，本文提出了一种新的范式，名为双向自适应跨模态融合提示学习，简称为Bloom。它主要包括两方面的改进：首先，Bloom使用映射函数进行双向的模态转换，然后通过融合函数实现对应层的图像和文本信息的双向交互。其次，Bloom采用一种自适应的方式，自动搜索每一层跨模态信息的最佳组合。这两个改进确保了两种模态信息更高效、灵活地融合，从而实现针对特定下游任务的正确对齐。本文在15个图像分类数据集上进行了评估，结果表明Bloom显著提升了提示学习的效果。
        </p>
        <div class="news-content-mark">
          <div>02</div>
          <div>AlignCLIP：使用对象交并比损失对CLIP模型的多域文本输入进行对齐</div>
          <div>AlignCLIP: Align Multi Domains of Texts Input for CLIP models with Object-IoU Loss</div>
        </div>
        <p class="short-center">
          Lu Zhang, Ke Yan, Shouhong Ding
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_1.png"/>
          </div>
        </div>
        <p>
          自从OpenAI发布CLIP模型以来，它受到了广泛关注。然而，现实世界中的类别往往表现出长尾分布，现有的CLIP模型在有效识别稀有的长尾类别（如濒危的非洲鸟类）方面存在困难。一个直观的想法是为这些长尾类别生成视觉描述，并利用这些描述创建类别原型进行分类。然而，实验表明，视觉描述、图像标题和测试提示模板属于三个不同的领域，导致了分布偏移。在本文中，我们提出使用标题中的对象解析技术，识别标题中包含的对象集合。在训练过程中，使用对象集合生成视觉描述和测试提示，从而对齐这三个领域，使文本编码器能够基于视觉描述生成类别原型。得益于获取的对象集合，我们的方法可以以较低成本构建多对多关系，并生成软标签，从而解决传统一对一匹配中存在的噪声问题。大量实验结果表明，我们的方法显著超越了CLIP基线，并超过了现有方法，达到了新的最先进水平（SOTA）。
        </p>
        <div class="news-content-mark">
          <div>03</div>
          <div>基于多模态提示训练的开集检测算法</div>
          <div>Multimodal Inplace Prompt Tuning for Open-set Object Detection</div>
        </div>
        <p class="short-center">
          Guilin Li（厦门大学）, Mengdan Zhang, Xiawu Zheng（厦门大学）, Peixian Chen, Zihan Wang, Yunhang Shen, Mingchen Zhuge（阿卜杜拉国王科技大学）, Chenglin Wu（深度赋智）, Fei Chao（厦门大学）, Ke Li, Xing Sun, Rongrong Ji（厦门大学）
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_2.png"/>
          </div>
        </div>
        <p>
          将大语言模型集成到开放世界检测框架中可显著提高新环境中的多功能性。从这些开放世界检测模型中得出的类别提示表征有助于为基本已知类别和新开放类别同时建立准确的分类边界。然而，我们首次发现直接在检测系统中微调语言模型会导致注意力模式冗余，并导致类别提示表征不理想。为了充分利用大语言模型的功能并增强检测的类别表征编码，本研究引入了冗余评估指标来识别统一的注意力模式。此外，在冗余度较高的区域，我们结合了多模态提示训练 (MIPT)，以视觉线索丰富文本提示。实验结果验证了我们的 MIPT 框架的有效性，在基准测试中实现了显著提升，例如在 ODinW-35 上将 GLIP-L 从 22.6% 提升到 25.0%，在 LVIS 上提高了 9.0%。
        </p>
        <div class="news-content-mark">
          <div>04</div>
          <div>Cantor: 多模态的思维链路方案</div>
          <div>Cantor: Inspiring Multimodal Chain-of-Thought of MLLM</div>
        </div>
        <p class="short-center">
          Timin Gao（厦门大学）, Peixian Chen, Mengdan Zhang, Chaoyou Fu, Yunhang Shen, Yan Zhang（厦门大学）, Shengchuan Zhang（厦门大学）, Xiawu Zheng（厦门大学）, Xing Sun, Liujuan Cao（厦门大学）, Rongrong Ji（厦门大学）
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_3.png"/>
          </div>
        </div>
        <p>
          随着思想链(CoT)方法增强的大型语言模型(llm)的出现，视觉推理问题通常被分解为多个子任务，并使用各种外部工具依次处理。然而，由于视觉信息的不足和低级感知工具的限制，这种范式面临着决策中潜在的“决定性幻觉”的挑战，这些工具无法提供全面推理所需的抽象总结。我们认为融合视觉语境获取和逻辑推理是解决视觉推理任务的关键。本文研究了多模态大语言模型及其认知能力在多模态大语言模型领域的应用，以解决复杂的视觉推理任务。为此，我们提出了一个创新的多模态CoT框架，称为Cantor，由感知-决策两部分架构组成。Cantor首先拥有一个决策生成器，整合视觉输入来分析图像和问题，确保与实际环境更接近。此后，Cantor利用mllm的高级认知功能，作为多面专家来派生更高层次的信息，增强CoT生成过程。我们的大量实验证明了所提出的框架的有效性，在两个复杂的视觉推理数据集上显示了多模态CoT性能的显着改善，而无需微调或基本真理原理。
        </p>
        <div class="download-article-wrap">
          <p>
            项目链接：
          </p>
          <p>
            https://arxiv.org/abs/2404.16033
          </p>
        </div>
        <div class="news-content-mark">
          <div>05</div>
          <div>MDT-A2G：探索基于音频的姿势生成的掩码扩散变换器（高校合作）</div>
          <div>MDT-A2G: Exploring Masked Diffusion Transformers for Co-Speech Gesture Generation</div>
        </div>
        <p class="short-center">
          Xiaofeng Mao, Zhengkai Jiang, Qilin Wang, Chencan Fu, Jiangning Zhang, Jiafu Wu, Yabiao Wang, Chengjie Wang, Wei Li, Mingmin Chi
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_4.png"/>
          </div>
        </div>
        <p>
          扩散变换器领域的最新进展显著提升了高质量2D图像、3D视频和3D形状的生成。然而，变换器架构在基于音频的姿势生成领域的有效性仍未得到充分探索，先前的方法主要采用卷积神经网络（CNNs）或简单的少量变换器层。为弥补这一研究空白，我们引入了一种新型的基于音频的姿势生成的掩码扩散变换器，称为MDT-A2G，该模型直接在姿势序列上实施去噪过程。为了增强时间对齐的语音驱动姿势的上下文推理能力，我们采用了一种新颖的掩码扩散变换器。该模型使用一种专门设计的掩码建模方案，以加强序列姿势之间的时间关系学习，从而加速学习过程并生成连贯且逼真的动作。除了音频外，我们的MDT-A2G模型还整合了多模态信息，包括文本、情感和身份。此外，我们提出了一种高效的推理策略，通过利用先前计算的结果来减少去噪计算，从而在几乎不影响性能的情况下实现加速。实验结果表明，MDT-A2G在手势生成方面表现出色，其学习速度比传统扩散变换器快6倍以上，推理速度比标准扩散模型快5.7倍。
        </p>
        <div class="download-article-wrap">
          <p>
            项目链接：
          </p>
          <p>
            https://arxiv.org/abs/2408.03312
          </p>
        </div>
        <div class="news-content-mark">
          <div>06</div>
          <div>基于相机-物体运动解耦的视频相机运动迁移方法（高校合作）</div>
          <div>COMD: Training-free Video Motion Transfer With Camera-Object Motion Disentanglement</div>
        </div>
        <p class="short-center">
          Teng Hu（上海交通大学）, Jiangning Zhang, Ran Yi（上海交通大学）, Yating Wang（上海交通大学）, Jieyu Weng（上海交通大学）, Hongrui Huang（哈尔滨工业大学）, Yabiao Wang, Lizhuang Ma（上海交通大学）
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_5.png"/>
          </div>
        </div>
        <p>
          近年来，生成模型的快速发展极大地推动了图像和视频生成领域的进步。扩散模型的出现使得生成高质量、多样性高的视频成为可能。尽管如此，在可控视频生成方面，特别是相机运动控制（相机运镜）仍面临诸多挑战。现有的方法往往依赖于训练一个时序相机模块，这不仅需要大量计算资源，而且在训练过程中预定义相机运动类型，限制了其在相机控制方面的灵活性。为了解决这些问题，我们提出了COMD，一种无需训练的相机运动转移模型，该模型能够从源视频中提取相机运动并转移到新的视频中。COMD的核心思想在于解耦源视频中的相机运动和物体运动，并将提取的相机运动转移到新的视频中。我们提出了一种one-shot相机运动解耦方法，通过从单个源视频中提取相机运动，将运动物体与背景分离，并基于背景中的相机运动来估计移动物体区域的相机运动。此外，我们还提出了一种few-shot相机运动解耦方法，通过对多个具有相似相机运动的视频进行窗口聚类技术，从多个视频的时序注意力图中提取出共同的相机运动特征。最后，我们提出了一种运镜组合方法，能够将不同类型的相机运动结合起来，使我们的模型能够实现更可控和灵活的相机控制，如变速变焦和希区柯克变焦等专业的运镜方式。
        </p>
        <div class="download-article-wrap">
          <p>
            项目链接：
          </p>
          <p>
            https://arxiv.org/pdf/2404.15789
          </p>
        </div>
        <div class="news-content-mark">
          <div>07</div>
          <div>MambaGesture: 使用 Mamba 和解耦多模态融合增强共语手势生成（高校合作）</div>
          <div>MambaGesture: Enhancing Co-Speech Gesture Generation with Mamba and Disentangled Multi-Modality Fusion</div>
        </div>
        <p class="short-center">
          Chencan Fu（浙江大学）, Yabiao Wang（浙大&优图）, Jiangning Zhang, Zhengkai Jiang, Xiaofeng Mao（复旦大学）, Jiafu Wu, Weijian Cao, Chengjie Wang（上海交大&优图）, Yanhao Ge（VIVO）, Yong Liu
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_6.png"/>
          </div>
        </div>
        <p>
          共语手势生成对于产生与语音同步且逼真的人类手势至关重要，这有助于增强虚拟形象的效果。当前扩散模型已经展示出令人印象深刻的能力，但目前的方法往往忽略了模态的广泛性以及其之间的相互作用关系，导致手势缺乏动态性和上下文多样性。为了解决这些挑战，我们提出了MambaGesture，集成了基于Mamba的MambaAttn模块和多模态特征融合模块SEAD。MambaAttn模块结合了Mamba模型的顺序数据处理优势和注意力机制的上下文丰富性，增强了生成手势的时间连贯性。SEAD融合了音频、文本、风格和情感模态，利用解耦技术加强融合过程，从而产生更具真实感和多样性的手势。我们的方法在多模态BEAT数据集上进行了评估，在多种指标上显示出明显改进，在共语手势生成中达到了最先进的水平。
        </p>
        <div class="download-article-wrap">
          <p>
            项目链接：
          </p>
          <p>
            https://arxiv.org/abs/2407.19976
          </p>
        </div>
        <div class="news-content-mark">
          <div>08</div>
          <div>基于频域分解Token的域泛化语义分割（高校合作）</div>
          <div>Learning Spectral-Decomposed Tokens for Domain Generalized Semantic Segmentation</div>
        </div>
        <p class="short-center">
          Jingjun Yi (武汉大学), Qi Bi (武汉大学), Hao Zheng, Haolan Zhan (蒙纳士大学), Wei Ji (耶鲁大学), Yawen Huang, Yuexiang Li (广西医科大学), Yefeng Zheng
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_7.png"/>
          </div>
        </div>
        <p>
          视觉基础模型的涌现和发展为各种类下游任务提供了更强的固有域泛化能力。为了进一步提升其在域泛化语义分割场景中的性能，本文提出了一种基于频域分解token的学习框架。相比于现有的基础模型微调范式，该方法特别关注于如何基于少量可学习的token来获取具有风格不变性的特征。冻结的VFM特征首先在频率空间中分解为相位和幅度分量，我们对两种分量使用各自的可学习的token来提取相关信息。分解后，风格变化更多地影响幅度分支中的特征表示。为了解决这个问题，我们进一步开发了一种针对注意力图的优化方法，以在推理过程中缓解特征因跨域图像风格不同所产生的变化与训练后静态token之间的矛盾。
        </p>
        <div class="news-content-mark">
          <div>09</div>
          <div>方面作为锚点：基于方面驱动对齐与精炼的多模态方面级情感分析方法（高校合作）</div>
          <div>Aspects are Anchors: Towards Multimodal Aspect-based Sentiment Analysis via Aspect-driven Alignment and Refinement</div>
        </div>
        <p class="short-center">
          Zhanpeng Chen（北京大学）, Zhihong Zhu（北京大学）, Wanshi Xu（北京大学）, Yunyan Zhang, Xian Wu, Yefeng Zheng
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_8.png"/>
          </div>
        </div>
        <p>在给定的句子图像对中，多模态方面级情感分析（Multimodal Aspect-based Sentiment Analysis, MABSA）旨在检测方面术语并预测其情感极性。尽管现有方法在对齐图像和文本以改善MABSA性能方面做出了巨大努力，但它们仍然难以有效地缓解噪声对应问题（noisy correspondence problem, NCP）的挑战：文本描述通常与视觉内容不太对齐。为了缓解NCP，在本文中，我们引入了面向方面的对齐和精炼（Aspect-driven Alignment and Refinement, ADAR），这是一个两阶段的由粗到细的对齐框架。在第一阶段，ADAR设计了一个由粗到细的面向方面的对齐模块，该模块引入了最优传输（Optimal Transport, OT）来学习视觉和文本特征之间的粗粒度对齐。然后，应用自适应滤波箱在细粒度级别去除无关的图像区域；在第二阶段，ADAR引入了一个面向方面的精炼模块，以进一步精炼跨模态特征表示。在两个基准数据集上的实验证明了我们的模型在MABSA任务中的优越性。</p>
        <div class="news-content-mark">
          <div>10</div>
          <div>InMu-Net: 基于信息瓶颈和多感官处理的多模态意图识别方法（高校合作）</div>
          <div>InMu-Net: Advancing Multi-modal Intent Detection via Information Bottleneck and Multi-sensory Processing</div>
        </div>
        <p class="short-center">
          Zhihong Zhu（北京大学）, Xuxin Cheng（北京大学）, Zhaorun Chen（芝加哥大学）, Yuyan Chen（复旦大学）, Yunyan Zhang, Xian Wu, Yefeng Zheng, Bowen Xing（北京科技大学）
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news61/news61_9.png"/>
          </div>
        </div>
        <p>多模态意图检测（MID）旨在通过多种模态理解用户的意图，是对话系统中重要的模块。现有工作在复杂的融合机制及架构设计方面取得了进步，但由于以下两个原因，仍然存在挑战：（1）视觉和音频模态中的各种噪声和冗余；（2）意图类别的长尾分布。为了解决上述两个问题，本文提出了InMu-Net，这是一个从信息瓶颈(Information bottleneck)和多感官处理(Multi-sensory processing)角度出发的简单而有效的MID框架。我们的贡献体现在三个方面。首先，我们设计了一个去噪瓶颈模块，用于过滤融合特征中与意图无关的信息；其次，我们引入了一个显著性保留损失，以防止意图相关信息的丢失；最后，我们引入了峰度调节，以在过滤过程中保持表示的平滑性，减轻长尾分布的不利影响。在两个MID基准数据集上的实验证明了InMu-Net及其关键组件的有效性，进一步的实验分析证明，我们在低资源、模态损坏、跨架构和跨任务场景中的去噪潜力和鲁棒性。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News61',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News61.vue